import type { AnyRouter } from '@tanstack/react-router'

/** Page changes that animate: the Agents screens hold streaming threads, which must never be frozen or re-laid out under a snapshot. */
export function shouldAnimate(from: string, to: string): boolean {
  if (from === to) return false
  const thread = (p: string) => p === '/agents' || p.startsWith('/agents/')
  return !thread(from) && !thread(to)
}

/**
 * Cross-fade the page between routes with the View Transitions API (Safari 18+, Chrome);
 * elsewhere, with reduced motion, or on a search-only change, there is no animation.
 * Only `main` is named (`.page-vt` in index.css), so the tab bar, its glass and the pill are not snapshotted.
 */
export function installViewTransitions(router: AnyRouter): void {
  if (typeof document === 'undefined' || typeof document.startViewTransition !== 'function') return
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)')
  router.subscribe('onBeforeLoad', (e) => {
    router.options.defaultViewTransition =
      e.pathChanged &&
      !reduced.matches &&
      shouldAnimate(e.fromLocation?.pathname ?? '', e.toLocation.pathname)
  })
}
